import React, { useEffect } from "react";
import * as R from "ramda";
import { connect } from "react-redux";

import { actions, getters } from "../../model";
import { getIsValid } from "../../selectors";
import { eventId as getEventId } from "redux/modules/event/selectors";

// import TextField from "@material-ui/core/TextField";
import { Div, BigFilledButton, UploadIcon } from "components/Base";

import FileTable from "./FileTable";
// import UrlsTable from "./UrlsTable";

import CSSModules from "react-css-modules";
import css from "./styles.scss";

const decorate = R.compose(
  CSSModules(css),
  connect(
    state => ({
      data: getters.fileUploadData(state),
      url: getters.fileUploadUrl(state),
      urls: getters.fileUploadUrls(state),
      urlMessage: getters.fileUploadUrlMessage(state),
      isValidUrl: getters.fileUploadIsValidUrl(state),
      uploadHasFinished: getters.fileUploadUploadHasFinished(state),
      isValid: getIsValid(state),
      eventId: getEventId(state),
      sessionId: getters.sessionId(state),
      settings: getters.settings(state),
      showModal: getters.showEditTypeModal(state),
      accentColor: getters.accentColor(state),
      viaPortal: getters.viaPortal(state)
    }),
    {
      save: actions.saveFileUpload,
      init: actions.initFileDropzone,
      onFileUploadProgress: actions.onFileUploadProgress,
      onFileUploadCancel: actions.onFileUploadCancel,
      onFileUploadFailed: actions.onFileUploadFailed,
      onFileUploadFinished: actions.onFileUploadFinished,
      validateUrl: actions.validateFileUploadUrl,
      addUrl: actions.addFileUploadUrl,
      setFileUploadUploadHasFinished: actions.setFileUploadUploadHasFinished
    }
  )
);

const FileDropzone = ({
  init,
  onFileUploadProgress,
  onFileUploadCancel,
  onFileUploadFailed,
  onFileUploadFinished,
  // validateUrl,
  // url,
  // urlMessage,
  // addUrl,
  // isValidUrl,
  uploadHasFinished,
  save,
  setFileUploadUploadHasFinished,
  // sessionId,
  settings = {},
  showModal = false,
  accentColor,
  viaPortal
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      init({
        onFileUploadProgress,
        onFileUploadCancel,
        onFileUploadFailed,
        onFileUploadFinished,
        settings
      });
    }, 300);
    return () => clearTimeout(timer);
  }, []);
  if (showModal) {
    return null;
  }
  return (
    <Div
      bg="white"
      style={{
        overflowY: "auto"
      }}
      className={viaPortal ? css.viaPortal : ""}
    >
      <Div
        style={{
          marginBottom: 20,
          cursor: "pointer",
          display: "inherit"
        }}
        id={`dropzone-container-without-modal`}
      />

      {/*
      <Div
        display="row.flex-start.center"
        style={{
          marginBottom: 20,
          display: "flex"
        }}
      >
        <TextField
          id="outlined-basic"
          variant="outlined"
          placeholder="Or link to an external file (e.g. YouTube, Google Doc) by pasting the URL here"
          onChange={e => validateUrl(e.target.value)}
          value={url}
          style={{ width: "100%", marginRight: 25 }}
          error={!R.isEmpty(urlMessage)}
          helperText={urlMessage}
          size="small"
        />
        <BigFilledButton
          bg="altB5"
          disabled={!isValidUrl}
          onClick={() => addUrl()}
          style={{
            backgroundColor: "white",
            color: "#4F4F4F",
            border: "2px solid #E0E0E0"
          }}
        >
          Upload
        </BigFilledButton>
      </Div>
      */}

      <FileTable />

      {/* <UrlsTable /> */}

      <BigFilledButton
        style={{
          marginTop: 20
        }}
        bg={accentColor ? accentColor : "altB5"}
        color="white"
        disabled={!uploadHasFinished}
        onClick={e => {
          setFileUploadUploadHasFinished(false);
          e.preventDefault();
          save();
        }}
        LeftIcon={UploadIcon}
      >
        Upload
      </BigFilledButton>
    </Div>
  );
};

export default decorate(FileDropzone);
